import translations from '../lang/translations.json'

export function useTranslations() {
  const translateValidation = (key) => {
    return translations.validation[key];
  }

  return {
    translateValidation
  };
}
